export default "__VITE_ASSET__DaMFDX0I__"